import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusDecisionForming.tsx
const IconApplicationStatusDecisionForming = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M5 3.333v3.334h10V3.333h1.672c.457 0 .828.371.828.828v13.344c0 .457-.37.828-.828.828H3.328a.83.83 0 0 1-.828-.828V4.161c0-.457.37-.828.828-.828zm2.5 10.834H5.833v1.666H7.5zm0-2.5H5.833v1.666H7.5zm0-2.5H5.833v1.666H7.5zm5.833-7.5V5H6.667V1.667z"
	})]
});
var IconApplicationStatusDecisionForming_default = forwardRef(IconApplicationStatusDecisionForming);
//#endregion
export { IconApplicationStatusDecisionForming_default as default };
